<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
                <div v-if="isRequiered" class="dx-field-item-required-mark">&nbsp;*</div>
            </div>
            <div class="dx-field-value">
                <div :class="fieldLabelClass">
                    <dx-radio-group
                        :disabled="isDisabled"
                        :displayExpr="meta.extParams.displayExpr"
                        :items="meta.extParams.items"
                        :layout="meta.extParams.layout"
                        :value="value"
                        :valueExpr="meta.extParams.valueExpr"
                        @valueChanged="valueChanged"
                    ></dx-radio-group>
                </div>
                <div v-if="error" class="ai-dx-invalid"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { DxRadioGroup } from 'devextreme-vue/radio-group';

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({}),
    },
    disableValue: {
        type: Boolean,
        default: () => false,
    },
    noClass: {
        type: Boolean,
        default: () => false,
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const validationResult = inject('validationResult');
const serverData = inject('serverData');
const userData = inject('userData');

const isDisabled = computed(() => props.disableValue);

const isRequiered = computed(() => {
    return props.meta.validationRules?.required;
});

const error = computed(() => {
    return validationResult.value.find(s => s.fieldNameText === props.meta.fieldNameText);
});

const isModified = computed(() => {
    return userData?.value[props.meta.fieldNameText] !== serverData?.value[props.meta.fieldNameText];
});

const value = computed(() => {
    if (userData?.value[props.meta.fieldNameText] === undefined) {
        return false;
    }
    return userData?.value[props.meta.fieldNameText];
});

const fieldLabelClass = computed(() => {
    if (props.noClass) return;
    return {
        'ai-field-modified': isModified.value,
    };
});

const valueChanged = e => {
    userDataChange(e.value);
};

const userDataChange = value => {
    validationResult.value = validationResult.value.filter(s => {
        return s.fieldNameText !== props.meta.fieldNameText;
    });
    userData.value[props.meta.fieldNameText] = value;
    if (props.callbacks.userDataChanged !== null) props.callbacks.userDataChanged();
};

defineExpose({
    userDataChange: userDataChange,
});
</script>
